import defaultsDeep from 'lodash/defaultsDeep';
import isEqual from 'lodash/isEqual';
import { useContext, useEffect, useState } from 'react';
import { UserAgentContext } from '../UserAgentContext';
import findMatchingQueries from './findMatchingQueries';
import guessUserAgentInfo from './guessUserAgentInfo';
const mergeProps = (propsArray) => {
    return defaultsDeep({}, ...propsArray.reverse());
};
const computeInitialPropsFromUserAgent = (userAgent, mediaQueriesToProps) => {
    const userAgentInfo = guessUserAgentInfo(userAgent);
    const mediaQueries = Object.keys(mediaQueriesToProps);
    const matchingQueries = findMatchingQueries(userAgentInfo, mediaQueries);
    const matchingProps = mediaQueries
        .filter((query) => matchingQueries[query])
        .map((query) => mediaQueriesToProps[query]);
    return mergeProps(matchingProps);
};
const mergeMatchingProps = (queryObjs) => {
    const matchingProps = queryObjs
        .filter((queryObj) => { var _a; return (_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.matches; })
        .map((queryObj) => queryObj.props);
    return mergeProps(matchingProps);
};
const useMediaProps = (mediaQueriesToProps) => {
    const userAgent = useContext(UserAgentContext);
    const initialProps = computeInitialPropsFromUserAgent(userAgent, mediaQueriesToProps);
    const [props, setProps] = useState(initialProps);
    useEffect(() => {
        const mediaQueries = Object.keys(mediaQueriesToProps);
        const queryObjs = mediaQueries.map((query) => {
            return {
                query,
                mediaQueryList: window === null || window === void 0 ? void 0 : window.matchMedia(query),
                props: mediaQueriesToProps[query],
            };
        });
        const computeProps = () => {
            const newProps = mergeMatchingProps(queryObjs);
            if (!isEqual(newProps, props)) {
                setProps(newProps);
            }
        };
        queryObjs.forEach((queryObj) => {
            var _a;
            if ((_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.addListener) {
                queryObj.mediaQueryList.addListener(computeProps);
            }
        });
        computeProps();
        return () => {
            queryObjs.forEach((queryObj) => {
                var _a;
                if ((_a = queryObj === null || queryObj === void 0 ? void 0 : queryObj.mediaQueryList) === null || _a === void 0 ? void 0 : _a.removeListener) {
                    queryObj.mediaQueryList.removeListener(computeProps);
                }
            });
        };
    }, [mediaQueriesToProps, props]);
    return props;
};
export default useMediaProps;
//# sourceMappingURL=useMediaProps.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
